document.addEventListener("DOMContentLoaded", () => {
	const audioElement = document.querySelector(".welten-sub__audio--welt");
	const playButtons = document.querySelectorAll(".menu-audio_playbtn");

	playButtons.forEach((button) => {
		button.classList.add("menu-audio_playbtn--animation");
	});

	if (!audioElement || !playButtons.length) return;

	let audioContext = null;
	let audioBuffer = null;
	let audioSource = null;
	let gainNode = null;
	let isPlaying = false;
	let currentTime = 0;
	let hasUserInteracted = false;
	let wasPlayingBeforeHidden = false;
	let startTime = 0;

	const audioFileUrl = audioElement.querySelector("source").src;
	const theme_uri = directory_name.templateUrl;

	// Initialize localStorage state
	if (localStorage.getItem("audioWasPlaying") === null) {
		localStorage.setItem("audioWasPlaying", "false");
	}
	const wasPlayingPreviously =
		localStorage.getItem("audioWasPlaying") === "true";

	updateButtonsState();

	// Initialize audio context immediately
	const initAudioContext = () => {
		if (!audioContext) {
			audioContext = new(window.AudioContext || window.webkitAudioContext)();
			gainNode = audioContext.createGain();
		}
	};

	async function loadAudioBuffer() {
		try {
			const response = await fetch(audioFileUrl);
			const arrayBuffer = await response.arrayBuffer();
			audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
		} catch (error) {
			console.error("Error loading audio buffer:", error);
		}
	}

	function stopAudio(isVisibilityChange = false) {
		if (audioSource) {
			const elapsed = audioContext.currentTime - startTime;
			currentTime = elapsed % audioBuffer.duration;
			audioSource.stop();
			audioSource.disconnect();
			audioSource = null;
		}
		isPlaying = false;
		if (!isVisibilityChange) {
			localStorage.setItem("audioWasPlaying", "false");
		}
		updateButtonsState();
	}

	async function playAudio(isVisibilityChange = false) {
		if (!audioBuffer || !audioContext) return;

		try {
			if (audioContext.state === "suspended") {
				await audioContext.resume();
			}

			if (audioSource) {
				stopAudio(isVisibilityChange);
			}

			audioSource = audioContext.createBufferSource();
			audioSource.buffer = audioBuffer;
			audioSource.connect(gainNode);
			gainNode.connect(audioContext.destination);

			audioSource.loop = true;
			audioSource.start(0, currentTime);
			startTime = audioContext.currentTime - currentTime;
			isPlaying = true;
			if (!isVisibilityChange) {
				localStorage.setItem("audioWasPlaying", "true");
			}
			updateButtonsState();
		} catch (error) {
			console.error("Play Audio Error:", error);
			isPlaying = false;
			updateButtonsState();
		}
	}

	function updateButtonsState() {
		playButtons.forEach((button) => {
			const buttonImg = button.querySelector("img");
			if (buttonImg) {
				buttonImg.src =
					isPlaying && audioContext?.state === "running" ?
					`${theme_uri}/assets/images/icon-sound_on.svg` :
					`${theme_uri}/assets/images/icon-sound_off.svg`;
			}
		});
	}

	if (wasPlayingPreviously) {
		// Click listener for desktop
		const clickHandler = async function() {
			if (!hasUserInteracted) {
				console.log("Click interaction detected");

				initAudioContext();
				await loadAudioBuffer();
				try {
					await playAudio();
					hasUserInteracted = true;
					// Only remove listener if playAudio was successful
					document.removeEventListener("click", clickHandler);
				} catch (error) {
					console.error("Play audio failed on click:", error);
					hasUserInteracted = false; // Reset to allow another attempt
				}
			}
		};
		document.addEventListener("click", clickHandler);

		// Touch listener for mobile
		const touchHandler = async function() {
			if (!hasUserInteracted) {
				console.log("Touch interaction detected");

				initAudioContext();
				await loadAudioBuffer();
				try {
					await playAudio();
					hasUserInteracted = true;
					// Only remove listener if playAudio was successful
					document.removeEventListener("touchend", touchHandler);
				} catch (error) {
					console.error("Play audio failed on touch:", error);
					hasUserInteracted = false; // Reset to allow another attempt
				}
			}
		};
		document.addEventListener("touchend", touchHandler);
	}

	async function handleButtonClick() {
		try {
			if (!hasUserInteracted) {
				await handleFirstInteraction();
			} else if (isPlaying) {
				stopAudio();
			} else {
				await playAudio();
			}
		} catch (error) {
			console.error("Button Click Error:", error);
		}
	}

	// Try autoplay on page load, but only if audioWasPlaying is true
	const tryAutoplay = async () => {
		try {
			// Only attempt autoplay if audio was playing in previous session
			if (wasPlayingPreviously) {
				initAudioContext();
				await audioContext.resume();
				await loadAudioBuffer();
				await playAudio();
			}
		} catch (error) {
			console.log("Autoplay failed, waiting for user interaction");
		}
	};

	tryAutoplay();

	async function handleButtonClick() {
		try {
			if (!audioContext) {
				initAudioContext();
				await loadAudioBuffer();
				await playAudio();
				hasUserInteracted = true;
			} else if (isPlaying) {
				stopAudio();
			} else {
				await playAudio();
			}
		} catch (error) {
			console.error("Button Click Error:", error);
		}
	}

	// Button event listeners
	playButtons.forEach((button) => {
		button.addEventListener("click", handleButtonClick);
	});

	document.addEventListener("visibilitychange", () => {
		if (document.hidden) {
			wasPlayingBeforeHidden = isPlaying;
			if (isPlaying) {
				stopAudio(true);
			}
		} else if (wasPlayingBeforeHidden) {
			playAudio(true);
			wasPlayingBeforeHidden = false;
		}
	});

	window.addEventListener("beforeunload", () => {
		localStorage.setItem("audioWasPlaying", isPlaying.toString());
		if (audioSource) {
			audioSource.stop();
		}
		if (audioContext) {
			audioContext.close();
		}
	});
});